import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import formatDate from 'helpers/formatDate';
import Icon, { iconTypes } from 'components/icon';
import { Thumb } from 'components/image';

import CardInfo from '../card-info';

const bemClassesUserShow = new Bem('userShow');

import 'styles/forum/common/voting/_user-show.scss';

// Show all users who voted on the current answer.
export default class UsersShow extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({})
  };

  render() {
    const { className, data = {} } = this.props;

    return (
      <div {...bemClassesUserShow({ extra: className })}>
        <div {...bemClassesUserShow('row')}>
          <div {...bemClassesUserShow('column')}>
            <div {...bemClassesUserShow('ava')}>
              <span {...bemClassesUserShow('imgContainer')}>
                <Thumb
                  {...bemClassesUserShow('img')}
                  image={{ id: data.avatar }}
                />
              </span>
            </div>
          </div>
          <div {...bemClassesUserShow('column', 'full')}>
            <div {...bemClassesUserShow('nick')}>
              <CardInfo
                userPhoto={{ id: data.avatar }}
                userName={data.forum_nick}
                userId={data.user_id}
              />
            </div>
            {data.user_rank && data.user_rank.name &&
              <div {...bemClassesUserShow('info')}>
                <div {...bemClassesUserShow('item')}>
                  <div {...bemClassesUserShow('status')}>
                    <span {...bemClassesUserShow('text')}>{data.user_rank.name}</span>
                  </div>
                </div>
              </div>
            }
            {data.date &&
              <div {...bemClassesUserShow('time')}>
                <Icon {...bemClassesUserShow('icon')} type={iconTypes.clock} />
                <span {...bemClassesUserShow('text')}>
                  {formatDate({
                    date: data.date,
                    format: 'dd mmm yyyy'
                  })}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}
